import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl'
import RichTextEditor from '../../common/rich-text/editor.component.jsx'
import $ from 'jquery'
import SideBar from '../../common/layout/sidebar.component.jsx'

class ProposalTemplatesEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            templateSection: {},
            title: '',
            content: '',
            enabled: false,
        }
        this.templateSectionId = this.props.match.params.templateSectionId
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submitTemplateSection = this.submitTemplateSection.bind(this);
        this.handleRichTextChange = this.handleRichTextChange.bind(this);
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        AppContext.getApiClient().get('/template-sections/' + this.templateSectionId).then(res => {
            this.setState({
                templateSection: res,
                title: res.attributes.title,
                content: res.attributes.content,
                enabled: res.attributes.enabled,
            })
            $('#content').focus()
        })
    }

    submitTemplateSection(event) {
        event.preventDefault()
        let updates = {}
        const allowedFormFields = ["content", "enabled"]

        for (let i = 0; i < allowedFormFields.length; i++) {
            let field = allowedFormFields[i]
            if (this.state[field] != this.state.templateSection.attributes[field]) {
                updates[field] = this.state[field]
            }
        }

        AppContext.getApiClient().patch('/template-sections/' + this.templateSectionId, updates).then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/settings' }} /> })
            }
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleRichTextChange(value) {
        this.setState({
            content: value
        });
    }

    render() {

        const messages = defineMessages({
            "settings.proposals.template.sections.form.edit.save_btn": {
                id: 'settings.proposals.template.sections.form.edit.save_btn',
                defaultMessage: 'Save',
            },
            "settings.proposals.template.sections.form.edit.content_placeholder": {
                id: 'settings.proposals.template.sections.form.edit.content_placeholder',
                defaultMessage: 'Section content',
            }
        })
        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    <FormattedMessage
                                        id="settings.proposals.template.sections.form.edit.title"
                                        defaultMessage="Edit : {sectionTitle}"
                                        values={{sectionTitle: this.state.title}}
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={this.submitTemplateSection}>
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module">
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="content">
                                    <FormattedMessage
                                        id="settings.proposals.template.sections.form.edit.content_label"
                                        defaultMessage="Content"
                                    />
                                </label>
                                <div className="col-10">
                                    <RichTextEditor
                                        rows="12"
                                        name="content"
                                        value={this.state.content}
                                        variables={this.state.content}
                                        onChange={this.handleRichTextChange}
                                        id="content"
                                        className="form-control"
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.proposals.template.sections.form.edit.content_description"
                                            defaultMessage="Content of the section"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-2" />
                                <div className="col-10">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            name="enabled"
                                            checked={this.state.enabled}
                                            onChange={this.handleFormChange}
                                            id="enabled"
                                        />
                                        <label className="form-check-label" htmlFor="enabled">
                                            <FormattedMessage
                                                id="settings.proposals.template.sections.form.edit.enabled_label"
                                                defaultMessage="Enabled"
                                            />
                                        </label>
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.proposals.template.sections.form.edit.enabled_description"
                                            defaultMessage="Enable the section add it to the proposal"
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            {this.state.formStatus}
                        </div>
                        <div className="col-12 ui-module">
                            <div className="row">
                                <div className="col-6 text-align-right">
                                    <Link to="/settings" className="btn btn-light">
                                        <FormattedMessage
                                            id="settings.proposals.template.sections.form.cancel_btn"
                                            defaultMessage="Cancel"
                                        />
                                    </Link>
                                    &nbsp;
                                    &nbsp;
                                    <input type="submit"
                                           value={this.props.intl.formatMessage(messages['settings.proposals.template.sections.form.edit.save_btn'])}
                                           className="btn btn-primary" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default injectIntl(ProposalTemplatesEditForm)


// WEBPACK FOOTER //
// ./src/settings/proposals/editForm.component.jsx